
export const environment = {
  production: false,
  apiBaseUrl: 'https://enfinapiv2.pozitivehub.com/api'
};
